/* eslint-disable react-hooks/exhaustive-deps */
import {FC, useContext, useState, useEffect, useMemo} from 'react'
import {useQuery} from 'react-query'
import {
  createResponseContext,
  initialQueryResponse,
  initialQueryState,
  PaginationState,
  QUERIES,
  stringifyRequestQuery,
} from '../../../../../resources/helpers'
import {getContacts} from './_requests'
import Customer from "../../../../models/Customer"
import {useQueryRequest} from './QueryRequestProvider'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../../../setup/redux/store'
import * as ContactRedux from '../../../../modules/contact/redux/ContactSlice'
import { contactSorting } from './_sort'

import {Response} from '../../../../../resources/helpers'

export type ContactsQueryResponse = Response<Customer[]>

const QueryResponseContext = createResponseContext<Customer>(initialQueryResponse)
const QueryResponseProvider: FC = ({children}) => {
  const {state} = useQueryRequest()
  const [query, setQuery] = useState<string>(stringifyRequestQuery(state))
  const updatedQuery = useMemo(() => stringifyRequestQuery(state), [state])
  const dispatch = useDispatch();
  const [counter, setCounter] = useState(0);
  let listContactdata:any = [];
  listContactdata = useSelector((state: RootState) => state.Contact.listContact); //list CIQ
  let ContactsQueryResponse: ContactsQueryResponse;

  useEffect(() => {
    if (query !== updatedQuery) {
      setQuery(updatedQuery)
    }
  }, [updatedQuery])

  
  useEffect(() => {
    console.log("Masuk use effect update list CIQ >>>>");
      setCounter(listContactdata.length)
  }, [listContactdata])

  const {
    isFetching,
    refetch,
    data: response,
  } = useQuery(
    `${QUERIES.USERS_LIST}-${query}-${counter}`,
    async () => {
      let data:any = [];

      //cek redux
      if (!listContactdata || listContactdata.length <= 0) {
        data = await getContacts(state.sort , state.order, state.search, state.action, state.lastId, state.items_per_page)
        if(data && data.length>0){
          dispatch(ContactRedux.setListContact(data));
        }
        // setCIQData(listCIQdata);
      }else{
        data = listContactdata;
      } 

      let resultData  = contactSorting(data , state.sort , state.items_per_page, state.action, state.order, state.search,  state.page, (lengthData: number)=> {
        if(state.search && state.search !== ""){
          dispatch(ContactRedux.setCountContact(lengthData));
        }
      })
      if(state.search && state.search !== ""){
      }else{
        dispatch(ContactRedux.setCountContact(listContactdata.length));
      }
      // console.log("Result Data : "+JSON.stringify(resultData));
      
      ContactsQueryResponse = {
          data: resultData,
      };
      return Promise.resolve(ContactsQueryResponse);
      
    },
    {cacheTime: 0, keepPreviousData: true, refetchOnWindowFocus: false,enabled: true}
  )

  return (
    <QueryResponseContext.Provider value={{isLoading: isFetching, refetch, response, query}}>
      {children}
    </QueryResponseContext.Provider>
  )
}

const useQueryResponse = () => useContext(QueryResponseContext)

const useQueryResponseData = () => {
  const {response} = useQueryResponse()
  if (!response) {
    return []
  }
  //console.log("response "+JSON.stringify(response));
  
  return response?.data || []
}

const useQueryResponsePagination = () => {
  const defaultPaginationState: PaginationState = {
    links: [],
    ...initialQueryState,
  }

  const {response} = useQueryResponse()
  if (!response || !response.payload || !response.payload.pagination) {
    return defaultPaginationState
  }

  return response.payload.pagination
}

const useQueryResponseLoading = (): boolean => {
  const {isLoading} = useQueryResponse()
  return isLoading
}

export {
  QueryResponseProvider,
  useQueryResponse,
  useQueryResponseData,
  useQueryResponsePagination,
  useQueryResponseLoading,
}
